import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
// All pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
// import DemoProduct from './pages/DemoProduct';

import { useDocTitle } from "./components/CustomHook";
import ScrollToTop from "./components/ScrollToTop";
import NewsLetter from "./pages/NewsLetter";
import About from "./pages/About";
import NavBar from "./components/Navbar/NavBar";
import Footer from "./components/Footer";
import Projects from "./pages/Projects";
import Single from "./pages/Single";
import SahabaVillasPage from "./pages/SahabaVillasPage";
import WhatsappButton from "./components/WhatsappButton";
import Careers from "./pages/Careers";
import Services from "./pages/Services";


// import { HashRouter } from 'react-router-dom';
import GarhoudVillas from "./pages/GarhoudVillas";
import Faq from "./pages/Faq";
import MyGallery from "./pages/MyGallery";




function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };

    window.addEventListener("load", () => {
      aos_init();
    });
  }, []);

  useDocTitle(
    "Al Ghaith Properties | Find your home,Grow your Life Discover Al Ghaith Communities"
  );

  return (
    <>
      <Router>
        <ScrollToTop>
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/whatsappbutton" element={<Projects />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/services" element={<Services />} />
            {/* <Route path="/gallery" element={<MyGallery />} /> */}
            <Route path="/projects/villa/sahabavillas" element={<SahabaVillasPage />} />
            <Route path="/projects/:id" element={<Single />} />
            <Route path="/faq" element={<Faq />} />
            {/* <Route path={"projects/:id"} element={<Single />} /> */}
            {/* <Route component={NotFoundPage} /> */}
          </Routes>
        </ScrollToTop>
        <Footer />
      </Router>
      {/* <div className="flex justify-center items-center h-screen">
        <button
          onClick={async () => { 
            const db = getFirestore(Firebase); 
            const prodtCol = collection(db, 'Careers'); 
            const prodtSnapshot = await getDocs(prodtCol); 
        
              const prodtList = prodtSnapshot.forEach((obj)=>{ 
              console.log(obj.data()) 
            }) 
            return prodtList; 
     
          }}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Click me
        </button> */}
      {/* </div> */}
      <div className='whatsapp'>
      <WhatsappButton/>
     </div>
    </>
  );
}

export default App;
